import React from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';
import { useStaticMenuExperiment } from 'experiments/static-menu/use-static-menu-experiment';
import { StaticMenuProvider, useStaticMenuContext } from 'state/static-menu';
import { useStoreContext } from 'state/store';
import { useIsBrowseMenu } from 'utils/menu/hooks/use-is-browse-menu';

import { MainMenuProvider, useMainMenuContext } from '../main-menu';
import { MenuOptionsProvider, useMenuOptionsContext } from '../menu-options';
import { MenuUIProvider } from '../menu-ui';

export type Menu = ReturnType<typeof useMainMenuContext> &
  ReturnType<typeof useMenuOptionsContext> &
  ReturnType<typeof useStaticMenuContext> & {
    showStaticMenu: boolean;
    showBurgersForBreakfast: boolean;
  };

export const useMenuContext = (currentUrl?: string): Menu => {
  const menuCtx = useMainMenuContext();
  const menuOptionsCtx = useMenuOptionsContext();
  const staticMenuData = useStaticMenuContext();

  const { isBrowseMenu } = useIsBrowseMenu(currentUrl ?? '');
  const enableStaticMenu = useStaticMenuExperiment();
  const { isStoreAvailable, isStoreOpenAndAvailable, store } = useStoreContext();

  const showStaticMenu =
    enableStaticMenu && (!isStoreAvailable || store.hasMobileOrdering === false || isBrowseMenu);
  const showBurgersForBreakfast = isStoreOpenAndAvailable && store?.hasBurgersForBreakfast === true;

  return {
    ...menuCtx,
    ...menuOptionsCtx,
    ...staticMenuData,
    showStaticMenu,
    showBurgersForBreakfast,
  };
};

export const MenuProvider = ({ children }: IBaseProps) => {
  return (
    <MainMenuProvider>
      <MenuOptionsProvider>
        <StaticMenuProvider>
          <MenuUIProvider>{children}</MenuUIProvider>
        </StaticMenuProvider>
      </MenuOptionsProvider>
    </MainMenuProvider>
  );
};
